// First, extend the Window interface to recognize the 'google' property
declare global {
    interface Window {
      google: any;
    }
  }
  
  import * as React from 'react';
  

  interface AddressAutocompleteProps {
    placeholder: string;
    inputStyle?: React.CSSProperties;
    className?: string;
    addressValue?: string; // Prop to pass the address1 value to the component
    onInputChange: any; 
    onAddressSelect: (address: {
      address1: string,
      address2: string,
      city: string,
      state: string,
      zipcode: string
    }) => void;
  }
  
class AddressAutocomplete extends React.Component<AddressAutocompleteProps, any> {
  // Declare the autocomplete input and Google Autocomplete instance as class properties
  autocompleteInput: HTMLInputElement | null = null;
  autocomplete: any = null;

  
  setAutocompleteInputRef = (element) => {
    this.autocompleteInput = element;
    if (this.autocompleteInput && this.props.addressValue) {
        this.autocompleteInput.value = this.props.addressValue;
    }
};

componentDidUpdate(prevProps) {
  if (prevProps.addressValue !== this.props.addressValue && this.autocompleteInput) {
      this.autocompleteInput.value = this.props.addressValue || '';
  }
}

  constructor(props: AddressAutocompleteProps) {
    super(props);
    this.handlePlaceSelected = this.handlePlaceSelected.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handlePlaceSelected = this.handlePlaceSelected.bind(this);
  }

  componentDidMount() {
    this.loadGooglePlacesScript(() => {
      this.initAutocomplete();
      // Register scroll event listener
      window.addEventListener('scroll', this.handleScroll);
    });
  }

  handleScroll = () => {
    // Only proceed if both the input element and the autocomplete are present
    console.log('handleScroll fired')
    if (this.autocompleteInput && this.autocomplete) {
      const rect = this.autocompleteInput.getBoundingClientRect();
      const autocompleteDropdown = document.querySelector('.pac-container') as HTMLElement; // TypeScript type assertion
  
      if (autocompleteDropdown) {
        autocompleteDropdown.style.top = `${rect.bottom}px`;
        autocompleteDropdown.style.left = `${rect.left}px`;
        autocompleteDropdown.style.position = 'fixed';
        autocompleteDropdown.style.zIndex = '1000';
      }
    }
  }
  

  componentWillUnmount() {
    // Make sure to remove the event listener when the component is unmounted
    window.removeEventListener('scroll', this.handleScroll);
  }

  handlePlaceSelected = () => {
    const place = this.autocomplete.getPlace();
    if (place) {
      let streetNumber = '';
      let route = '';
      let city = '';
      let state = '';
      let zipcode = '';
      
      for (const component of place.address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            streetNumber = `${component.long_name} `;
            break;
          }
          case "route": {
            route = component.long_name;
            break;
          }
          case "locality": {
            city = component.long_name;
            break;
          }
          case "administrative_area_level_1": {
            state = component.short_name;
            break;
          }
          case "postal_code": {
            zipcode = component.long_name;
            break;
          }
          // Ignore other address components
        }
      }
  
      const address1 = `${streetNumber}${route}`;
      console.log(`Extracted Address: ${address1}, City: ${city}, State: ${state}, Zip: ${zipcode}`);

      // Pass the individual components to the onAddressSelect prop
      this.props.onAddressSelect({ address1, address2: '', city, state, zipcode });
    }
  };
  
  

  loadGooglePlacesScript(callback: () => void) {
    if (window.google && window.google.maps && window.google.maps.places) {
      callback();
      return;
    }

    const existingScript = document.getElementById('googlePlacesScript');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBNoaMNNosLC5wP6k-8oSqxiI2JQNDBvIE&libraries=places`;
      script.id = 'googlePlacesScript';
      document.body.appendChild(script);

      script.onload = () => {
        if (callback) callback();
      };
    } else if (callback) {
      callback();
    }
  }

  initAutocomplete() {
      // Ensure the input ref and window.google.maps are available
      if (!this.autocompleteInput || !window.google || !window.google.maps) return;
      this.autocomplete = new window.google.maps.places.Autocomplete(this.autocompleteInput, { types: ['address'] });
      this.autocomplete.addListener('place_changed', this.handlePlaceSelected);
    }


// AddressAutoComplete component

render() {
  const { placeholder, inputStyle, className } = this.props;

  return (
      <input
          ref={this.setAutocompleteInputRef}
          type="text"
          defaultValue="" // Remove this since you're manually setting the value now
          placeholder={placeholder}
          style={inputStyle}
          className={className}
          onChange={(e) => {
              // Assert the target as an HTMLInputElement to access its value
              const target = e.target as HTMLInputElement;
              this.props.onInputChange(target.value); // Now TypeScript knows target has a value property
          }}
      />
  );
}
}

  export default AddressAutocomplete;
  